import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { getProductsByCategory } from "../../store/actions/product";
import { createCustomer } from "../../store/actions/customer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import Widget from "../../components/shared/Widget";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import { Link } from "react-router-dom";
import ProductItem from "../../components/ProductItem";
import Loading from "../../components/shared/Loading";

import styles from "../../thema/style";

class Register extends Component {
  state = {
    errors: [],
    full_name: "",
    email: "",
    phone: "",
    password: "",
    passwordC: ""
  };

  renderErrorMessage() {
    if (this.props.customer.errors.length > 0) {
      return (
        <div
          className="alert alert-danger"
          role="alert"
          style={{ marginTop: 20 }}
        >
          <h4 className="alert-heading">Hata Meydana Geldi!</h4>
          <p>
            <ul>
              {this.props.customer.errors.map((error, i) => (
                <li key={i}>{error.message}</li>
              ))}
            </ul>
          </p>
        </div>
      );
    }

    if (this.state.errors.length > 0) {
      return (
        <div
          className="alert alert-danger"
          role="alert"
          style={{ marginTop: 20 }}
        >
          <h4 className="alert-heading">Hata Meydana Geldi!</h4>
          <p>
            <ul>
              {this.state.errors.map((error, i) => <li key={i}>{error}</li>)}
            </ul>
          </p>
        </div>
      );
    } else {
      return null;
    }
  }

  validate = () => {
    const errors = [];
    if (!this.state.full_name)
      errors.push("Adınız Soyadınız alanı boş bırakılamaz!");
    if (!this.state.email) errors.push("E-Mail alanı boş bırakılamaz!");
    if (!this.state.password) errors.push("Şifreniz alanı boş bırakılamaz!");
    if (!this.state.passwordC)
      errors.push("Şifreniz (Tekrar) alanı boş bırakılamaz!");
    if (this.state.password !== this.state.passwordC)
      errors.push("Şifreniz ve Şifreniz (Tekrar) alanları aynı olmalıdır!");
    return errors;
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = e => {
    e.preventDefault();
    let location = "/";
    if (
      typeof this.props.location.state !== "undefined" &&
      this.props.location.state.location
    ) {
      location = this.props.location.state.location;
    }
    this.setState({ errors: this.validate() });
    if (this.state.errors.length === 0) {
      this.props.createCustomer({ ...this.state }, location);
    }
  };

  policyPages() {
    const membershipAgreement = this.props.page.page.find(
      ({ location }) => location === "membership_agreement"
    );

    const privacyPolicy = this.props.page.page.find(
      ({ location }) => location === "privacy_policy"
    );

    const distanceSalesContract = this.props.page.page.find(
      ({ location }) => location === "distance_sales_contract"
    );

    return (
      <React.Fragment>
        {membershipAgreement && (
          <div
            className="modal fade bd-example-modal-lg"
            id="membership_agreement"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {membershipAgreement.content_title}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div
                  className={"modal-body"}
                  dangerouslySetInnerHTML={{
                    __html: membershipAgreement.content
                  }}
                />
              </div>
            </div>
          </div>
        )}

        {privacyPolicy && (
          <div
            className="modal fade bd-example-modal-lg"
            id="privacy_policy"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {privacyPolicy.content_title}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div
                  className={"modal-body"}
                  dangerouslySetInnerHTML={{ __html: privacyPolicy.content }}
                />
              </div>
            </div>
          </div>
        )}

        {distanceSalesContract && (
          <div
            className="modal fade bd-example-modal-lg"
            id="distance_sales_contract"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {distanceSalesContract.content_title}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div
                  className={"modal-body"}
                  dangerouslySetInnerHTML={{
                    __html: distanceSalesContract.content
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
  render() {
    if (this.props.customer.customer) {
      return (
        <Redirect
          to={{
            pathname: "/hesabim"
            // state: { referrer: currentLocation }
          }}
        />
      );
    }
    return (
      <React.Fragment>
        {this.policyPages()}
        <PageTitle title={"Hesap Oluştur"} />
        <div className="row">
          <div className={"col-md-8 offset-md-2"}>
            <div className={styles.loginBox}>
              <div className={"overlay-content"} />
              <div className={"tab-content"}>
                <h3>Yeni Hesap Oluştur</h3>
                <form onSubmit={this.onSubmit}>
                  <div className={"clearfix large_form"}>
                    <input
                      type="text"
                      name="full_name"
                      defaultValue={this.state.full_name}
                      placeholder="Adınız Soyadınız"
                      onChange={e => {
                        this.handleChange(e);
                      }}
                      required
                    />
                  </div>
                  <div className={"clearfix large_form"}>
                    <input
                      type="email"
                      name="email"
                      defaultValue={this.state.email}
                      placeholder="E-mail Adresiniz"
                      onChange={e => {
                        this.handleChange(e);
                      }}
                      required
                    />
                  </div>
                  <div className={"clearfix large_form"}>
                    <input
                      type="text"
                      name="phone"
                      defaultValue={this.state.phone}
                      placeholder="Telefon Numaranız"
                      onChange={e => {
                        this.handleChange(e);
                      }}
                    />
                  </div>
                  <div className={"clearfix large_form"}>
                    <input
                      type="password"
                      name="password"
                      placeholder="Şifreniz"
                      onChange={e => {
                        this.handleChange(e);
                      }}
                      required
                    />
                  </div>
                  <div className={"clearfix large_form"}>
                    <input
                      type="password"
                      name="passwordC"
                      placeholder="Şifreniz (Tekrar)"
                      onChange={e => {
                        this.handleChange(e);
                      }}
                      required
                    />
                  </div>
                  <div className={"clearfix large_form text-right"}>
                    <Link to={"/sifremi-unuttum"} className={"forgot-password"}>
                      Şifremi Unuttum
                    </Link>
                  </div>
                  <div className={"clearfix large_form text-left"}>
                    <p>
                      Hesabımı oluştur butonuna basarak{" "}
                      {this.props.page.page.findIndex(
                        ({ location }) => location === "membership_agreement"
                      ) >= 0 && (
                        <React.Fragment>
                          <a
                            href="#"
                            data-toggle="modal"
                            data-target="#membership_agreement"
                          >
                            Üyelik Sözleşmesi
                          </a>’ni,
                        </React.Fragment>
                      )}
                      {this.props.page.page.findIndex(
                        ({ location }) => location === "privacy_policy"
                      ) >= 0 && (
                        <React.Fragment>
                          <a
                            href="#"
                            data-toggle="modal"
                            data-target="#privacy_policy"
                          >
                            Gizlilik ve Çerez Politikası
                          </a>’nı,
                        </React.Fragment>
                      )}
                      {` `}okuduğunuzu ve kabul ettiğinizi onaylıyorsunuz.
                    </p>
                    <button type="submit">HESABIMI OLUŞTUR</button>
                    {this.renderErrorMessage()}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ customer, page }) => {
  return { customer, page };
};

const mapDispatchToProps = { createCustomer };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Register);



// WEBPACK FOOTER //
// ./src/routers/Register/index.js